
import '../App.css';
import Header from '../components/Header';
import Donation from "../components/Donation";
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <Donation/>
    
    <Footer/>
    </div>
  );
}

export default App;
